module.exports = __webpack_public_path__ + "img/replay-24px.acc40335.svg";